function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M295.023,70.021c-10.653-20.379-25.378-36.617-43.763-48.265C228.47,7.32,200.047,0,166.78,0s-61.69,7.32-84.48,21.757 c-18.386,11.647-33.11,27.886-43.763,48.265c-17.745,33.944-18.257,67.888-18.257,71.646v182.064c0,1.4,0.001,2.673,0.036,3.596 c0.214,5.784,4.052,6.233,5.223,6.233c2.327,0,3.61-1.173,7.316-4.88l0.213-0.214l34.969-44.641l34.895,44.274l0.392,0.441 c2.747,2.745,7.7,4.738,11.779,4.738h3.416c4.08,0,9.033-1.993,11.779-4.739l0.21-0.21l35.064-44.56l34.909,44.311l0.393,0.441 c2.756,2.756,7.71,4.756,11.779,4.756h3.416c4.08,0,9.034-1.993,11.78-4.739l0.21-0.21l35.063-44.559l34.906,44.444l0.396,0.447 c1.47,1.47,5.23,4.888,8.402,4.888c3.98,0,6.452-3.763,6.452-9.82V141.668C313.28,137.909,312.768,103.966,295.023,70.021z  M109.354,170.146c-17.999,0-32.59-14.591-32.59-32.59s14.591-32.59,32.59-32.59s32.591,14.591,32.591,32.59 S127.353,170.146,109.354,170.146z M223.354,170.146c-17.999,0-32.59-14.591-32.59-32.59s14.591-32.59,32.59-32.59 s32.591,14.591,32.591,32.59S241.353,170.146,223.354,170.146z"
});

var SvgGhost = function SvgGhost(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 333.561 333.561",
    style: {
      enableBackground: "new 0 0 333.561 333.561"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGhost, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ghost.c504eec3.svg";
export { ForwardRef as ReactComponent };